import React from 'react';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-rose-950 text-white py-8 border-y-4 border-amber-500" data-id="element-260">
      <div className="max-w-6xl mx-auto px-4" data-id="element-261">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-rose-900" data-id="element-262">
          <div className="flex flex-col items-center justify-center" data-id="element-263">
            <Users className="w-8 h-8 mb-2 text-rose-300" data-id="element-264" />
            <span className="text-2xl md:text-3xl font-bold" data-id="element-265">+1.500</span>
            <span className="text-sm text-rose-200 uppercase tracking-wider mt-1" data-id="element-266">
              DOCENTES
              <br data-id="element-267" />
              TODO EL PAÍS
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-268">
            <BookOpen className="w-8 h-8 mb-2 text-rose-300" data-id="element-269" />
            <span className="text-2xl md:text-3xl font-bold" data-id="element-270">12</span>
            <span className="text-sm text-rose-200 uppercase tracking-wider mt-1" data-id="element-271">
              TOMOS LISTOS
              <br data-id="element-272" />
              PARA USAR
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-273">
            <Star className="w-8 h-8 mb-2 text-amber-400" data-id="element-274" />
            <span className="text-2xl md:text-3xl font-bold" data-id="element-275">4.9/5 ⭐</span>
            <span className="text-sm text-rose-200 uppercase tracking-wider mt-1" data-id="element-276">
              CALIFICACIÓN
              <br data-id="element-277" />
              CONFÍAN
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-278">
            <MapPin className="w-8 h-8 mb-2 text-rose-300" data-id="element-279" />
            <span className="text-2xl md:text-3xl font-bold" data-id="element-280">🇦🇷</span>
            <span className="text-sm text-rose-200 uppercase tracking-wider mt-1" data-id="element-281">
              TODO EL PAÍS
              <br data-id="element-282" />
              PRIM. Y SEC.
            </span>
          </div>
        </div>
      </div>
    </section>;
}